import { combineEpics } from 'redux-observable';
import { newUploadedFile$ } from './newUploadedFile$';
import { finishEvalAppointment$ } from './finishEvalAppointment$';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default combineEpics(newUploadedFile$, finishEvalAppointment$);
